import React, { useEffect } from "react";
import Daycarecon from "./Daycarecon";
import Infiry from "../../About/Infiry";
import Callin from "../../About/Callin";
import Servicebanner from "../../Services/Servicebanner";
import NumberInfo from "../../Home/NumberInfo";
import Doctorbox from "../../Home/Docterbox";
import Divser from "../../About/Divser";
import Divider from "../../Divider";
import ServiceReview from "../../Services/ServiceReview";
import { movetop } from "../../../fun";
import { Helmet } from "react-helmet-async";

function Daycare() {
  type elem = {
    oneBody?: JSX.Element;
    twoBody?: JSX.Element;
    threeBody?: JSX.Element;
  };
  const elemnt: elem = {
    oneBody: <Daycarecon />,
    twoBody: <Infiry />,
    threeBody: <Callin />,
  };

  useEffect(() => {
    movetop();
  }, []);
  return (
    <>
      <Helmet>
        <title>Best daycare centre in Whitefield</title>
        <meta
          name="description"
          content="We are the Best daycare centre in Whitefield and Vijayanagar. Feel free to contact us today or call us for an appointment."
        />
        <meta
          name="keywords"
          content="Best Daycare Service in Whitefield, Best Daycare Service in Vijayanagar, healthcare services in Whitefield, healthcare services in Vijayanagar, Multispeciality Clinic in Vijayanagar"
        />

        {/* JSON-LD Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "MedicalBusiness",
            "@id":
              "https://www.elvhealthcare.com/bestdaycareservicesinwhitefield#organization",
            name: "ELV Health Care Polyclinics",
            url: "https://www.elvhealthcare.com/bestdaycareservicesinwhitefield",
            description:
              "ELV Health Care Polyclinics offers comprehensive daycare services in Whitefield, Bangalore, including pediatric daycare, elder care, post-surgical care and chronic disease support under expert medical supervision.",
            logo: "https://www.elvhealthcare.com/logo.png",
            image:
              "https://www.elvhealthcare.com/bestdaycareservicesinwhitefield/og-image.jpg",
            telephone: "+91-9535264855",
            email: "elvhealthcare@gmail.com",
            address: {
              "@type": "PostalAddress",
              streetAddress: "MR ASTER, Ground Floor, Vijayanagar, Whitefield",
              addressLocality: "Bengaluru",
              addressRegion: "Karnataka",
              postalCode: "560066",
              addressCountry: "IN",
            },
            geo: {
              "@type": "GeoCoordinates",
              latitude: 12.971389,
              longitude: 77.75013,
            },
            hasMap:
              "https://www.google.com/maps/place/Whitefield,+Bengaluru,+Karnataka+560066",
            openingHoursSpecification: {
              "@type": "OpeningHoursSpecification",
              dayOfWeek: [
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday",
                "Sunday",
              ],
              opens: "00:00",
              closes: "23:59",
            },
            serviceType: [
              "Pediatric Daycare Services",
              "Elder Care and Senior Daycare",
              "Post-Surgical & Rehabilitation Daycare",
              "Chronic Disease & Special Needs Daycare",
            ],
            knowsAbout: [
              "Daycare medical services for children",
              "Elder daycare with medical supervision",
              "Post-surgical recovery support",
              "Rehabilitation and physiotherapy programs",
              "Special needs and chronic disease care",
            ],
            keywords: [
              "Best Daycare services in Immadihalli",
              "Best Daycare services in Whitefield",
              "Best Daycare services in Bangalore",
              "Best Daycare services in Kundalahalli",
              "Best Daycare services in Pattandur Agrahara",
            ],
          })}
        </script>
      </Helmet>
      <h2 style={{ display: "none" }}>
        Best daycare centre in Whitefield where ELV Health Care Polyclinics
        stands as a beacon of health and healing for our community. Are you
        looking for the best daycare centre in Whitefield? Contact us today.
      </h2>

      <Servicebanner name="Day care center" banner={"../photo/dd1.jpg"} />
      <NumberInfo test="test-black" />
      <Doctorbox />
      <Divser elemnt={elemnt} />
      {/* <div className="pt-6">
            <Divider />
          </div>
          <Doctorbox /> */}
      <div className="pt-10 pb-4">
        <Divider />
      </div>
      <ServiceReview />
    </>
  );
}

export default Daycare;
